import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'aboutus',
    templateUrl: './aboutus.component.html'
})
export class AboutUsComponent {
}

